






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { PageModel, SurveyModel } from 'survey-vue';
import { Section } from '@/types';
import { ActionTypes } from '@/store/actions';
import ShowHideLink from '@/components/ShowHideLink.vue';

@Component({
  components: { ShowHideLink },
})
export default class SurveySectionCard extends Vue {
  @Prop() public section!: PageModel;
  @Prop() public survey!: SurveyModel;

  collapsed = true;

  toggleCollapsed() {
    this.collapsed = !this.collapsed;
  }

  goToSection(sectionName: string) {
    this.survey.currentPage = sectionName;
    this.$store.dispatch(ActionTypes.UpdateSurveyData, this.survey);
    this.$store.dispatch(ActionTypes.UpdateCurrentPageName, sectionName);
    this.$router.push('/questions');
  }

  getShortDescription(description: string) {
    let maxLen = 280;
    if (description.length <= maxLen) return description;
    return description.substr(0, description.lastIndexOf(' ', maxLen)) + '... ';
  }

  sectionScoreLevel(sectionName: string) {
    const thisSection: Section = this.$store.getters.returnSectionByName(sectionName);
    if (thisSection === undefined) {
      return 'N/A';
    }
    let scorePercentage: string = new Intl.NumberFormat('en-CA', {
      style: 'decimal',
      maximumFractionDigits: 0,
    }).format((thisSection.userScore / thisSection.maxScore) * 100);
    if (scorePercentage === 'NaN' || scorePercentage === '0') {
      return 'N/A';
    } else {
      return scorePercentage + '%';
    }
  }

  setStatusIcon(sectionName: string) {
    const thisSection: Section = this.$store.getters.returnSectionByName(sectionName);
    if (thisSection !== undefined && thisSection.userScore > 0) {
      return 'fa fa-2x fa-circle';
    } else {
      return 'zero fa fa-2x fa-circle';
    }
  }
}
